module.exports = __webpack_public_path__ + "img/phone3.198097d5.png";